import { SliceCreator } from '../TrainingState';
import { UserSlice } from './UserSlice';
import {
  UpdateNameMutation,
  UpdateNameMutationVariables,
  UpdateNameDocument
} from '~/data';
import { client } from '~/data/client';

/**
 * Saves user name on the back-end
 * @param variables The GraphQL query variables
 * @returns The values that have been updated
 */
export async function persistName(variables: { id: string; name: string }) {
  const result = await client.mutate<
    UpdateNameMutation,
    UpdateNameMutationVariables
  >({
    mutation: UpdateNameDocument,
    variables
  });

  if (result.errors?.length || result.data?.updateName?.errors.length) {
    throw new Error('Error saving settings...');
  }

  return variables.name;
}

export const createUserSlice: SliceCreator<UserSlice> = (set, get) => {
  /**
   * Save user name to the back-end and updates the local store
   * @param newValues contain new user name
   */
  async function updateUserName(
    newValues: Partial<UpdateNameMutationVariables>
  ) {
    const { learnerTrainingId, firstName } = get();

    return await persistName({
      id: learnerTrainingId,
      name: firstName,
      ...newValues
    });
  }

  return {
    firstName: '',
    companyName: '',
    companyId: '',
    logoUrl: '',
    setFirstName: (newFirstName: string) => {
      updateUserName({ name: newFirstName }).then(userName => {
        set({ firstName: userName });
      });
    }
  };
};
